module.exports = __webpack_public_path__ + "static/media/pic5.04123758.jpg";